import { render, staticRenderFns } from "./CertificationApplications.vue?vue&type=template&id=0296c85f&scoped=true&"
import script from "./CertificationApplications.vue?vue&type=script&lang=js&"
export * from "./CertificationApplications.vue?vue&type=script&lang=js&"
import style0 from "./CertificationApplications.vue?vue&type=style&index=0&id=0296c85f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0296c85f",
  null
  
)

export default component.exports